(function() {
  function initSlickSlider() {
    const sections = document.querySelectorAll('.lanai-related-product-slider-section');
    sections.forEach(function(section) {
      const track = section.querySelector('.lanai-related-product-slider-track');
      if (!track) return;

      // If Slick already initialized, destroy it first
      if ($(track).hasClass('slick-initialized')) {
        $(track).slick('unslick');
      }

      $(track).slick({
        slidesToShow: 3,       // desktop default
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: section.querySelector('.prev-arrow'),
        nextArrow: section.querySelector('.next-arrow'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlickSlider);
  } else {
    initSlickSlider();
  }

  // Re-run after Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && document.querySelector(`#shopify-section-${event.detail.sectionId}`)) {
      initSlickSlider();
    }
  });
})();


$(document).ready(function() {
  
  $('.cl-page .cl-grid-wrap .cl-product-grid .card-wrapper.product-card-wrapper .card.card--standard.card--media .card__content .card__information .card-information .price .price__container .price__regular span').each(function() {
        $(this).text($(this).text().replace(/From\s*/i, ''));
    });
});

document.addEventListener('mouseover', function(e) {
  document.querySelectorAll('.has-hover').forEach(function(el) {
    el.classList.remove('has-hover');
  });
}, true);